import { useQuery } from "@tanstack/react-query";

import { QueryConfig } from "@/lib/react-query";
import { ScenarioBuilderClient } from "@/pages/scenario-builder/api/client/scenarioClient";
import { useScenarioBuilderClient } from "@/pages/scenario-builder/api/hooks/useScenarioBuilderClient";
import { Scenario } from "../getScenario";
import { ScenarioTypeEnum } from "@/pages/scenario-builder/types";

type AnalyseSpendAllocationStrategyOptions = {
  scenarioBuilderClient: ScenarioBuilderClient;
  scenarioUuid: string;
};

const analyseSpendAllocationStrategy = ({
  scenarioBuilderClient,
  scenarioUuid,
}: AnalyseSpendAllocationStrategyOptions) => {
  return scenarioBuilderClient.scenarios.analyzeSpendAllocationStrategy({
    scenarioUuid,
  });
};

type UseAnalyseAllocationStrategyOptions = {
  scenario: Scenario | undefined;
  config?: QueryConfig<typeof analyseSpendAllocationStrategy>;
};

export const useAnalyseSpendAllocationStrategy = ({
  scenario,
  config,
}: UseAnalyseAllocationStrategyOptions) => {
  const scenarioBuilderClient = useScenarioBuilderClient();
  return useQuery({
    // Whenever the scenario budget or constraint changes, we need to re-run the analysis.
    queryKey: [
      "analyse-allocation-strategy",
      scenario?.uuid,
      scenario?.value,
      scenario?.scenarioConstraints,
      scenario?.scenarioType,
    ],
    enabled:
      !!scenario &&
      !!scenario.uuid &&
      scenario.scenarioType === ScenarioTypeEnum.Budget &&
      !!scenario.value,
    queryFn: async () =>
      await analyseSpendAllocationStrategy({
        scenarioBuilderClient,
        scenarioUuid: scenario?.uuid ?? "",
      }),
    ...config,
  });
};
